<template>
  <div class="scrollable">
    <el-table
      :data="items"
      border
      fit
      stripe
      lazy
      style="width: 100%"
      v-loading="loading"
      ref="table"
      class="table-box card-base card-shadow--medium"
      max-height="550"
    >
      <el-table-column width="50" fixed align="center">
        <template slot="header" slot-scope="scope">
          <i class="el-icon-setting" :key="scope.$index"></i>
        </template>
        <template slot-scope="scope">
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
              <i class="mdi mdi-menu" :key="scope.$index"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="{
                  index: scope.$index,
                  row: scope.row,
                  command: 'view'
                }"
                icon="el-icon-view"
                >Ver detalle</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
      <el-table-column
        prop="Id"
        label="NO"
        column-key="Id"
        width="70"
        sortable
      />
      <el-table-column
        label="Codigo"
        width="100"
        prop="ComplaintCode"
        sort-by="ComplaintCode"
        column-key="ComplaintCode"
        sortable
      />
      <el-table-column
        prop="CustomerName"
        label="Cliente"
        min-width="200"
        column-key="CustomerName"
        sort-by="CustomerName"
        sortable
      />
      <el-table-column
        label="Descripcion"
        column-key="Comments"
        sort-by="Comments"
        min-width="200"
      >
        <template slot-scope="scope">
          <template v-if="scope.row.Comments.length < 30">
            <span>
              {{ scope.row.Comments }}
            </span>
          </template>
          <template v-else>
            <el-popover placement="top" style="cursor: pointer" width="500">
              <div v-html="formatComments(scope.row.Comments)"></div>
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium">{{
                  scope.row.Comments.substring(0, 30) + "..."
                }}</el-tag>
              </div>
            </el-popover>
          </template>
        </template>
      </el-table-column>
      <el-table-column
        v-if="activeName == 0 || activeName == 1"
        prop="Id"
        label=""
        min-width="40"
        column-key="Id"
      >
        <template slot-scope="scope">
          <el-button
            type="danger"
            size="mini"
            icon="el-icon-delete"
            @click="CloseComplaint(scope)"
            round
            >Cerrar</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="pagination.currentPage"
      :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next"
      :total="pagination.total"
      style="margin-top: 20px"
    />
    <!-- formulario de detalle  -->
    <el-drawer
      title="Detalle queja o reclamación"
      :visible.sync="drawer"
      size="50%"
      ref="drawer"
      v-loading="drawerLoading"
      direction="rtl"
    >
      <div class="" style="padding: 20px">
        <el-form :model="detail" label-position="top">
          <h2 style="margin-bottom: 0px">Inconveniente</h2>

          <p>{{ detail.Comments }}</p>

          <hr />
          <el-form-item
            label="Responsable"
            :value="detail.ResponsableBy.FullName"
            style="margin-top: 10px; font-weight: bold"
          >
            <el-input
              v-model="detail.ResponsableBy.FullName"
              class="fields"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            label="Código del cliente"
            :value="detail.ClientCode"
            style="margin-top: 20px; font-weight: bold"
          >
            <el-input
              v-model="detail.ClientCode"
              class="fields"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            label="Nombre del cliente"
            :value="detail.CustomerName"
            style="margin-top: 10px; font-weight: bold"
          >
            <el-input
              v-model="detail.CustomerName"
              class="fields"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            label="RNC ó cedula"
            :value="detail.CustomerIdentification"
            style="margin-top: 10px; font-weight: bold"
          >
            <el-input
              v-model="detail.CustomerIdentification"
              class="fields"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            label="Motivo"
            :value="detail.ComplaintReasons"
            style="margin-top: 10px; font-weight: bold"
          >
            <el-input
              v-model="detail.ComplaintReasons"
              class="fields"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            label="Metodo de recepción"
            :value="detail.ComplaintReceptions"
            style="margin-top: 10px; font-weight: bold"
          >
            <el-input
              v-model="detail.ComplaintReceptions"
              class="fields"
              disabled
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-row>
          <el-col>
            <rabbey-table
              ref="tableQ"
              :headers="headers"
              :actions="actions"
              index-url="/api/ComplaintsAndClaims/311/details"
              @get:data="getDataComplaint"
            />
          </el-col>
        </el-row>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import COLUMNS from "@/columns/complaint";

const ACTIONS = [
  {
    icon: "el-icon-view",
    label: "Ver",
    command: "view"
  }
];

export default {
  name: "ComplaintTable",
  data() {
    return {
      headers: COLUMNS,
      actions: ACTIONS,
      activeName: "",
      pagination: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      loading: false,
      departmentId: 2,
      productId: 0,
      serviceRequestTypeId: 0,
      technicalId: 0,
      items: [],
      drawer: false,
      drawerLoading: false,
      detail: {
        id: 0,
        ClientCode: "",
        CustomerName: "",
        CustomerIdentification: "",
        ResponsableById: 0,
        ComplaintReasons: 0,
        ComplaintReceptions: 0,
        ComplaintType: 0,
        ComplaintStatus: 0,
        Comments: "",
        ComplaintCode: "",
        Date: "",
        ClosedDate: "",
        ResponsableBy: {}
      }
    };
  },
  mounted() {
    this.getDataComplaint();
    //this.getData2();
  },
  methods: {
    getData(
      Status,
      ComplaintType = null,
      ComplaintReasons = null,
      ComplaintReceptions = null
    ) {
      this.loading = true;
      this.activeName = Status;

      const url = `/api/ComplaintsAndClaims`;

      this.$http
        .get(url, {
          timeout: 25000, // Esta llama puede tardar mucho.
          params: {
            CompanyCode: this.currentCompany,
            Limit: this.pagination.pageSize,
            Page: this.pagination.currentPage,
            Status: Status,
            ComplaintType: ComplaintType,
            ComplaintReasons: ComplaintReasons,
            ComplaintReceptions: ComplaintReceptions
          }
        })
        .then((resp) => {
          this.loading = false;
          this.items = resp.data.Items;
          this.pagination.total = resp.data.ItemCount;
          this.pagination.currentPage = resp.data.CurrentPage;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getData(this.activeName);
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getData(this.activeName);
    },
    formatDate(date, toFormat = "DD/MM/YYYY hh:mm:ss") {
      // date => "2020-06-25T10:54:07.28" or "2020-06-25T10:54:07.280"
      let format = "YYYY-MM-DDTHH:mm:ss.SS";

      if (date.length === 23) {
        format = "YYYY-MM-DDTHH:mm:ss.SSS";
      }
      let mDate = this.$moment(date, format);

      if (mDate.isValid()) {
        return mDate.format(toFormat);
      }
      return "";
    },
    getDataComplaint() {
      const table = this.$refs.tableQ;
      const config = {
        params: {
          "criteria.companyCode": this.$store.state.user.user.CompanySelected,
          "criteria.Page": table.pagination.currentPage,
          "criteria.Limit": table.pagination.pageSize
        }
      };
      table.indexConfig = config;
      table.getDataComplaint();
    },
    handleCommand(c) {
      // http://localhost:44308/api/serviceRequests/23082/details

      switch (c.command) {
        case "view": {
          this.drawer = true;
          this.drawerLoading = true;
          const url = `/api/ComplaintsAndClaims/${c.row.Id}/details`;

          this.$http
            .get(url)
            .then((resp) => {
              this.drawerLoading = false;
              const request = resp.data;

              // seteo de valores para inputs
              this.detail.ClientCode = request.ClientCode;
              this.detail.CustomerName = request.CustomerName;
              this.detail.CustomerIdentification =
                request.CustomerIdentification;
              this.detail.Comments = request.Comments;
              if (request.ResponsableBy != null)
                this.detail.ResponsableBy = request.ResponsableBy;
              else this.detail.ResponsableBy.FullName = "Sin responsable";

              if (request.ComplaintReasons == 0)
                this.detail.ComplaintReasons = "Queja";
              else this.detail.ComplaintReasons = "Reclamación";
              switch (request.ComplaintReceptions) {
                case 0:
                  this.detail.ComplaintReceptions = "Telefono";
                  break;
                case 1:
                  this.detail.ComplaintReceptions = "Correo";
                  break;
                case 2:
                  this.detail.ComplaintReceptions = "Personal";
                  break;
                case 3:
                  this.detail.ComplaintReceptions = "Redes Sociales";
                  break;
                case 4:
                  this.detail.ComplaintReceptions = "Portal Web";
                  break;
              }
              // seteo de valores para la tabla movimiento
              //this.getDataComplaint();
            })
            .catch((err) => {
              this.drawerLoading = false;
              this.$alert(err.message, err.name, {
                type: "error"
              });
            });
          break;
        }

        case "edit":
          break;

        case "delete":
          break;

        default:
          break;
      }
    },
    handleClose(done) {
      this.$confirm("Are you sure you want to close this?")
        .then(() => {
          done();
        })
        .catch(() => {});
    },
    formatComments(comments) {
      return comments.split("•").join("<br/>");
    },
    CloseComplaint(scope) {
      const BaseUrl =
        "/api/ComplaintsAndClaims/UpdateComplaintsAndClaimsStatus";

      this.$http
        .post(BaseUrl + `?ComplaintCode='${scope.row.ComplaintCode}'`)
        .then(() => {
          this.$ref.table.getData();
        })
        .catch((err) => {
          console.error("Error: ", err);
        })
        .finally(() => {
          const complainIndex = this.items.findIndex(
            (complain) => complain.Id == scope.row.Id
          );
          this.items.splice(complainIndex, 1);
        });
    }
  }
};
</script>

<style>
.el-dropdown-link {
  cursor: pointer;
  color: #3c3c3c;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>
